'use client';

import styled from "styled-components";

export const Wrapper = styled.section`
  position: relative;
  max-width: 1150px;
  margin: 0 auto;
  padding: 30px 16px 0;
`;

export const Container = styled.div`
  width: 100%;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 60vh;
`;